import { RootState } from 'src/store';
import { createSelector } from '@reduxjs/toolkit';

const safeSelector = (rootState: RootState) => rootState['sitesSlice'];

export const allUserSitesSelector = createSelector(safeSelector, (sites) => sites.sites);
export const loadingAllUserSitesSelector = createSelector(
  safeSelector,
  (allSites) => allSites.loading,
);
export const errorAllUserSitesSelector = createSelector(safeSelector, (allSites) => allSites.error);
